export default "__VITE_ASSET__ConuU6DR__"